


















import {Vue, Component} from 'vue-property-decorator';

@Component({
    name: 'ArrowDownIcon',
})
export default class ArrowDownIcon extends Vue {

}
